'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import L from 'leaflet';
import {loadMaptilerLayer, loadOpentopoLayer, loadSatelliteLayer} from './MapLayers';

const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');

export default class RaceMap extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    id: PropTypes.number.isRequired,
    markerPos: PropTypes.array.isRequired,
    fullscreen: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.map = null;
    this.mapContainerId = 'race-map-' + genRanHex(5);
    this.waypoints = this.props.data;
    this.height = '350px';
  }

  setMarker() {
    const posLatLng = [this.props.markerPos[0], this.props.markerPos[1]];
    return L.marker(posLatLng).addTo(this.map);
  }

  changeMarkerPosition(pos) {
    var latlng = [pos[0], pos[1]];
    this.marker.setLatLng(latlng);
  }

  mapOptions() {
    return {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    const oldMarkerPos = this.props.markerPos;
    const newMarkerPos = nextProps.markerPos;
    if (oldMarkerPos[0] !== newMarkerPos[0] || oldMarkerPos[1] !== newMarkerPos[1]) {
      this.changeMarkerPosition(nextProps.markerPos);
      return true;
    }
    return false;
  }

  componentDidMount() {
    // Create observer to render the map when it comes into the viewport
    this.createObserver();
  }

  // Add Observer which listens to intersection with map container
  createObserver() {
    const elem = document.querySelector('#' + this.mapContainerId);
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), { root: null, rootMargin: '0px'} );

    observer.observe(elem);
  }

  handleIntersect(entries, _observer) {
    entries.forEach((entry) => {
      // Render the map when intersection is reported
      if (entry.isIntersecting && this.map === null) {
        this.renderMap();
      }
    });
  }

  renderMap() {
    const maptilerLayer = loadMaptilerLayer();
    const topoLayer = loadOpentopoLayer();
    const satelliteLayer = loadSatelliteLayer();

    // Track
    const polyline = L.polyline(this.waypoints, { color: '#be1723', weight: 3 });

    this.map = L.map(this.refs.map, {
      zoom: 10,
      layers: [maptilerLayer, polyline],
      preferCanvas: true,
    }).setView([51.505, -0.09], 13);
    this.map.fitBounds(polyline.getBounds());

    const baseMaps = {
      'Swisstopo': maptilerLayer,
      'Opentopo': topoLayer,
      'Satellite': satelliteLayer,
    };
    const overlayMaps = {
      "GPS Track": polyline,
    };
    L.control.layers(baseMaps, overlayMaps).addTo(this.map);
    this.marker = this.setMarker();
  }

  render() {
    return (
      <div className="map-canvas">
        <div className="map-canvas-child" id={this.mapContainerId} ref="map" style={{ width: '100%' }} />
        { !this.map && <div className="center-md"></div> }
      </div>
    );
  }
}